(() => {
    const section = document.querySelector('[data-countup-section]');

    if (!section) {
        return;
    }

    const counters = [...section.querySelectorAll('strong')].map((counter) => {
        const finalText = counter.textContent.trim();
        const match = finalText.match(/^(\D*)([\d,]+)(.*)$/);

        if (!match) {
            return null;
        }

        return {
            element: counter,
            prefix: match[1],
            target: Number(match[2].replaceAll(',', '')),
            suffix: match[3],
            grouped: match[2].includes(','),
            decimals: match[3].startsWith('M') ? 2 : 0,
            finalText
        };
    }).filter(Boolean);

    if (!counters.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    const format = (counter, value) => {
        const number = counter.grouped ? value.toLocaleString('en-US') : (counter.decimals ? value.toFixed(counter.decimals) : String(value));
        return `${counter.prefix}${number}${counter.suffix}`;
    };

    counters.forEach((counter) => {
        counter.element.textContent = format(counter, 0);
    });

    let hasAnimated = false;
    const duration = 3500;

    const animate = () => {
        if (hasAnimated) {
            return;
        }

        hasAnimated = true;
        const startedAt = performance.now();

        const frame = (now) => {
            const progress = Math.min((now - startedAt) / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);

            counters.forEach((counter) => {
                const value = counter.decimals ? counter.target * eased : Math.round(counter.target * eased);
                counter.element.textContent = progress === 1 ? counter.finalText : format(counter, value);
            });

            if (progress < 1) {
                requestAnimationFrame(frame);
            }
        };

        requestAnimationFrame(frame);
    };

    if (!('IntersectionObserver' in window)) {
        animate();
        return;
    }

    const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
            observer.disconnect();
            animate();
        }
    }, {threshold: 0.25});

    observer.observe(section);
})();
